export const api = {
  // 公共接口
  getDeviceListByPage: '/bms/device/getDeviceListByPageApi.json', // 查询设备列表
  queryAreaDeviceTree: '/bms/device/queryAreaDeviceTree.json', // 查询设备树

  // 音频管理相关接口
  // queryAudio: '/bms/audiomanagement/queryAudio.json', // 查询音频文件列表-私用
  queryAudio: '/bms/audiomanagement/queryAudioApi.json', // 查询音频文件列表-公用
  addAudio: '/bms/audiomanagement/addAudio.json', // 新增音频文件
  deleteAudio: '/bms/audiomanagement/deleteAudio.json', // 删除音频文件
  syncAudio: '/bms/audiomanagement/syncAudio.json', // 同步音频文件

  // 远程喊话相关接口
  addRemoteCallTemplate: '/bas/remotecall/addRemoteCallTemplate.json', // 新增广播喊话源终端模板
  queryRemoteCallTemplate: '/bas/remotecall/queryRemoteCallTemplate.json', // 查询广播喊话源终端模板列表
  deleteRemoteCallTemplate: '/bas/remotecall/deleteRemoteCallTemplate.json', // 删除广播喊话源终端模板
  manualRemoteCall: '/bas/remotecall/manualRemoteCall.json', // 创建远程喊话
  queryRemoteCall: '/bas/remotecall/queryRemoteCall.json', // 查询远程喊话
  deleteRemoteCall: '/bas/remotecall/deleteRemoteCall.json', // 删除远程喊话
  queryDeviceDistanceList: '/bms/device/queryDeviceDistanceList.json', //根据摄像机返回的广播数据
  queryPlayAudio: '/bas/remotecall/queryPlayAudio.json', // 查询音频播放
  playAudio: '/bas/remotecall/playAudio.json', // 创建音频播放
  stopPlayAudio: '/bas/remotecall/stopPlayAudio.json', // 停止/启动广播音频播放
  controlPlayAudio: '/bas/remotecall/controlPlayAudio.json', // 控制音频播放（上一首、下一首、播放、暂停）
  deletePlayAudio: '/bas/remotecall/deletePlayAudio.json', // 删除音频播放
  //摄像头配置任务记录
  queryControlTaskCamera: '/vas/controltask/queryControlTaskCamera.json',
  setVolume: '/bas/remotecall/setVolume.json', // 设置广播设备音量

  // 联动播放广播相关接口
  addLinkage: '/bas/linkagebroadcast/addLinkage.json', // 添加广播联动规则
  updateLinkage: '/bas/linkagebroadcast/updateLinkage.json', // 修改广播联动规则
  deleteLinkage: '/bas/linkagebroadcast/deleteLinkage.json', // 删除广播联动规则
  queryLinkage: '/bas/linkagebroadcast/queryLinkage.json', // 查询广播联动规则列表
  queryLinkageDetail: '/bas/linkagebroadcast/queryLinkageDetail.json' // 查询广播联动规则详情
}